import { render, staticRenderFns } from "./PostalNumber.vue?vue&type=template&id=0db3780c&scoped=true&"
import script from "./PostalNumber.vue?vue&type=script&lang=js&"
export * from "./PostalNumber.vue?vue&type=script&lang=js&"
import style0 from "./PostalNumber.vue?vue&type=style&index=0&id=0db3780c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db3780c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0db3780c')) {
      api.createRecord('0db3780c', component.options)
    } else {
      api.reload('0db3780c', component.options)
    }
    module.hot.accept("./PostalNumber.vue?vue&type=template&id=0db3780c&scoped=true&", function () {
      api.rerender('0db3780c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/common/Input/PostalNumber.vue"
export default component.exports